document.addEventListener("DOMContentLoaded", () => {
  const addBtns = document.querySelectorAll(".template-product [data-add-btn]");
  const mainCTA = document.querySelector(".product-form__buttons .product-form__submit");

  if (!addBtns.length || !mainCTA) return;

  addBtns.forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      // Scroll smoothly to main CTA
      mainCTA.scrollIntoView({ behavior: "smooth", block: "center" });

      // Trigger CTA click after short delay (wait until scroll completes)
      setTimeout(() => {
        mainCTA.click();
      }, 800); // adjust timing if needed
    });
  });
});
